import { render, staticRenderFns } from "./FirstStep.vue?vue&type=template&id=c4df24fa&scoped=true&"
import script from "./FirstStep.vue?vue&type=script&lang=ts&"
export * from "./FirstStep.vue?vue&type=script&lang=ts&"
import style0 from "./FirstStep.vue?vue&type=style&index=0&id=c4df24fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4df24fa",
  null
  
)

export default component.exports